module.exports = __webpack_public_path__ + "videos/color_en.687d5ba.mp4";